export const CATEGORIES = [
  "all",
  "sports",
  "music",
  "boxing",
  "gym",
  "trending",
  "live",
  "fashion",
  "flowers",
  "shorts",
  "soccer",
  "tennis",
  "basketBall",
  "housing",
  "gaming",
  "news",
  "finance",
  "stocks",
  "technology",
  "apple",
  "tesla",
  "history",
];
